module.exports = __webpack_public_path__ + "static/img/kehuanli-2.62082ffa.jpg";